import { useEffect } from "react";
import { API_LOANS } from "../../constants/apis";
import { COMPONENT, LOANS } from "../../constants/constants";
import { TSet } from "../common/useSet";
import { showConfetti } from "../../components/elements/ConfettiView";
import { reloadData } from "../../components/lists/ListHandler";
import { FundSourceCard, CalculatorCard } from "../../components/elements/CardElements";
import { InfoBox } from "../../components/elements/Elements";
import { INFO_YELLOW } from "../../constants/colors";
import { currencyFormat } from "../../utils/helpers";
import useGet from "../common/useGet";
import { SimpleLoader } from "../../components/common/Loader";
import { useWallet } from "../wallets/useWallet";
import { transactionPinField } from "../../utils/pinUtils";

export const useEarlySettlementForm = ({ state }: any) => {
  const loan = state || {};
  const { id: loanId } = loan;
  const { getWalletBalance } = useWallet();

  const { loadData, data: preview, loading } = useGet();

  useEffect(() => {
    if (loanId) {
      loadData({ api: `${API_LOANS}${loanId}/early-settle-preview/` });
    }
  }, [loanId]);

  const fields = [
    {
      type: COMPONENT,
      visible: loading,
      component: <SimpleLoader />,
    },
    {
      type: COMPONENT,
      visible: !loading && !!preview,
      component: (
        <div className="textCenter p10">
          <div className="font16 bold textDark">Early Settlement</div>
          <div className="font13 grey">
            Pay off your remaining balance and close this loan early.
          </div>
        </div>
      ),
    },
    {
      type: COMPONENT,
      visible: !loading && !!preview,
      component: preview ? (
        <CalculatorCard
          title="Settlement Breakdown"
          fields={{
            outstanding_balance: currencyFormat(preview.outstanding_balance),
            early_settlement_fee: currencyFormat(preview.early_settlement_fee),
            total_settlement_amount: currencyFormat(preview.total_settlement_amount),
          }}
        />
      ) : null,
    },
    { ...transactionPinField, visible: !loading && !!preview },
    {
      type: COMPONENT,
      visible: !loading && !!preview,
      component: <FundSourceCard />,
    },
    {
      type: COMPONENT,
      visible: !loading && !!preview,
      component: (
        <InfoBox color={INFO_YELLOW}>
          The total of{" "}
          <b>
            {preview
              ? currencyFormat(preview.total_settlement_amount)
              : "..."}
          </b>{" "}
          will be deducted from your wallet. This loan will be marked as
          completed.
        </InfoBox>
      ),
    },
  ];

  const onSubmit = ({ payload }: any = {}): TSet => {
    return {
      api: `${API_LOANS}${loanId}/early-settle/`,
      params: { confirm: true, pin: payload?.pin },
      method: "POST",
      successMessage: {
        message: "Loan settled early! Congratulations!",
        duration: 7,
      },
      onSuccess: () => {
        reloadData(LOANS);
        showConfetti();
        getWalletBalance();
      },
    };
  };

  return {
    fields,
    onSubmit,
    title: "Early Settlement",
    submitText: preview
      ? `Pay ${currencyFormat(preview.total_settlement_amount)}`
      : "Settle Now",
    allowSubmit: !loading && !!preview,
  };
};